var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsFrame5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#FFAC30",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4688 10.1875C20.4688 10.1295 20.4457 10.0738 20.4047 10.0328C20.3637 9.9918 20.308 9.96875 20.25 9.96875H14.125C13.4868 9.96875 12.8748 10.2223 12.4235 10.6735C11.9723 11.1248 11.7188 11.7368 11.7188 12.375V24.625C11.7188 25.2632 11.9723 25.8752 12.4235 26.3265C12.8748 26.7777 13.4868 27.0312 14.125 27.0312H22.875C23.5132 27.0312 24.1252 26.7777 24.5765 26.3265C25.0277 25.8752 25.2812 25.2632 25.2812 24.625V16.0036C25.2812 15.9456 25.2582 15.89 25.2172 15.8489C25.1762 15.8079 25.1205 15.7849 25.0625 15.7849H21.125C20.951 15.7849 20.784 15.7157 20.661 15.5927C20.5379 15.4696 20.4688 15.3027 20.4688 15.1286V10.1875ZM21.125 18.7188C21.299 18.7188 21.466 18.7879 21.589 18.911C21.7121 19.034 21.7812 19.201 21.7812 19.375C21.7812 19.549 21.7121 19.716 21.589 19.839C21.466 19.9621 21.299 20.0312 21.125 20.0312H15.875C15.701 20.0312 15.534 19.9621 15.411 19.839C15.2879 19.716 15.2188 19.549 15.2188 19.375C15.2188 19.201 15.2879 19.034 15.411 18.911C15.534 18.7879 15.701 18.7188 15.875 18.7188H21.125ZM21.125 22.2188C21.299 22.2188 21.466 22.2879 21.589 22.411C21.7121 22.534 21.7812 22.701 21.7812 22.875C21.7812 23.049 21.7121 23.216 21.589 23.339C21.466 23.4621 21.299 23.5312 21.125 23.5312H15.875C15.701 23.5312 15.534 23.4621 15.411 23.339C15.2879 23.216 15.2188 23.049 15.2188 22.875C15.2188 22.701 15.2879 22.534 15.411 22.411C15.534 22.2879 15.701 22.2188 15.875 22.2188H21.125Z",
    fill: "#FFAC30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7812 10.471C21.7812 10.31 21.9501 10.2076 22.0753 10.3083C22.1811 10.394 22.2765 10.4938 22.3579 10.6075L24.9943 14.2799C25.0538 14.3639 24.989 14.4724 24.8858 14.4724H22C21.942 14.4724 21.8863 14.4494 21.8453 14.4083C21.8043 14.3673 21.7812 14.3117 21.7812 14.2536V10.471Z",
    fill: "#FFAC30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsFrame5);
export default __webpack_public_path__ + "static/media/stats_frame_5.5b5d0332c9015d076fcc8dce7a230bd2.svg";
export { ForwardRef as ReactComponent };